<template>
	<div class="dashboard">
		Panel Principal
	</div>
</template>

<script>
	import mixin from '@/mixins'
	export default {
		name: 'Dashboard',
		mixins: [mixin],
	}
</script>
